import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlModifyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.5 10.08C22.09 10.08 21.75 10.42 21.75 10.83V20.16C21.75 21.03 21.04 21.74 20.17 21.74H3.83C2.96 21.74 2.25 21.03 2.25 20.16V3.83C2.25 2.96 2.96 2.25 3.83 2.25H13.16C13.57 2.25 13.91 1.91 13.91 1.5C13.91 1.09 13.57 0.75 13.16 0.75H3.83C2.13 0.75 0.75 2.13 0.75 3.83V20.16C0.75 21.86 2.13 23.24 3.83 23.24H20.16C21.86 23.24 23.24 21.86 23.24 20.16V10.83C23.24 10.42 22.9 10.08 22.49 10.08H22.5Z"
        fill={color}
      />
      <path
        d="M23.34 1.52L22.48 0.660004C21.71 -0.109996 20.46 -0.109996 19.69 0.660004L6.29996 14.05C6.15996 14.19 6.07996 14.38 6.07996 14.58V17.17C6.07996 17.58 6.41996 17.92 6.82996 17.92H9.41996C9.61996 17.92 9.80996 17.84 9.94996 17.7L23.34 4.31C24.11 3.58 24.11 2.25 23.34 1.52ZM22.28 3.25L9.10996 16.42H7.57996V14.89L20.75 1.72C20.93 1.54 21.23 1.54 21.42 1.72L22.28 2.58C22.46 2.76 22.46 3.07 22.28 3.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlModifyIcon.displayName = 'CtrlModifyIcon';
